var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "damage-item" }, [
    _vm.damage.images.length > 0 &&
    _vm.flowName !== "damage_billma_agent_new" &&
    _vm.flowName !== "e2e_new"
      ? _c("figure", { staticClass: "damage-img" }, [
          _c("img", { attrs: { src: _vm.damage.images[0].thumbnailURL } }),
        ])
      : _vm._e(),
    _c("p", { staticClass: "damage-name" }, [
      _vm._v(_vm._s(_vm.damage.literal)),
    ]),
    _c("div", { staticClass: "damage-icons" }, [
      _c(
        "div",
        {
          staticClass: "buton-action",
          on: {
            click: function ($event) {
              return _vm.$emit("editDamage")
            },
          },
        },
        [
          _c("svgicon", {
            staticClass: "icon",
            attrs: {
              name: "ico-edit",
              color: "#005BA5",
              width: "16.67",
              height: "auto",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "buton-action",
          on: {
            click: function ($event) {
              return _vm.$emit("deleteDamage")
            },
          },
        },
        [
          _c("svgicon", {
            staticClass: "icon",
            attrs: {
              name: "ico-delete",
              color: "#005BA5",
              width: "16.67",
              height: "auto",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }